import { render } from "./OrderEdit.vue?vue&type=template&id=7ad56d0f&scoped=true"
import script from "./OrderEdit.vue?vue&type=script&lang=js"
export * from "./OrderEdit.vue?vue&type=script&lang=js"

import "./OrderEdit.vue?vue&type=style&index=0&id=7ad56d0f&scoped=true&lang=css"

import exportComponent from "/home/denis/Projects/tavria/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad56d0f"]])

export default __exports__